import { cva, type VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'react'
import { cn } from '../lib/cn'

/**
 * Etiqueta de status — componente 02. Quatro níveis, do mais leve ao mais grave:
 * `done` (contorno ink · concluído) · `waiting` (contorno cinza · aguardando) ·
 * `attention` (contorno plum · depende de ação sua) · `critical` (plum preenchido · risco jurídico:
 * procedimento feito sem documento assinado, link vencido).
 * Retangular, sem ícone, status por extenso. Nunca pílula colorida.
 */
export const statusTagVariants = cva(
  'inline-flex items-center px-[9px] py-[5px] font-body text-eyebrow font-light leading-[1.3] tracking-normal whitespace-nowrap',
  {
    variants: {
      level: {
        done: 'border border-ink text-ink',
        waiting: 'border border-hairline-heavy text-secondary',
        attention: 'border border-hairline-plum text-plum',
        critical: 'bg-plum text-pampas',
      },
    },
    defaultVariants: { level: 'waiting' },
  },
)

export type StatusLevel = NonNullable<VariantProps<typeof statusTagVariants>['level']>

export interface StatusTagProps
  extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof statusTagVariants> {}

export function StatusTag({ className, level, ...props }: StatusTagProps) {
  return (
    <span
      data-slot="status-tag"
      data-level={level}
      className={cn(statusTagVariants({ level }), className)}
      {...props}
    />
  )
}
